export const HEAT_SYSTEMS = [
  { displayName: 'radiator', code: 'hs_rad' },
  { displayName: 'underfloorHeating', code: 'hs_floor' },
  { displayName: 'convector', code: 'hs_conv' },
  { displayName: 'other', code: 'hs_other' }
] as const;

export type HeatSystem = (typeof HEAT_SYSTEMS)[number];
